import { t } from 'i18next';
import { Modal, Props as ModalProps } from 'components/Modal';
import { Heading } from 'components/Typography';
import { Button } from 'components/Button';

export type ScheduleConfirmationResponse = 'success' | 'inactive' | 'notfound';
type ScheduleConfirmationModalProps = {
  status: ScheduleConfirmationResponse | null;
  modalProps: ModalProps;
  onConfirm: () => void;
};

const ScheduleConfirmationModalMap = new Map([
  [
    'inactive',
    {
      title: t('schedule.confirm.appointmentNoLongerValidTitle'),
      message: t('schedule.confirm.appointmentNoLongerValidDescription'),
      cta: t('schedule.confirm.selectNewAppointment'),
    },
  ],
  [
    'notfound',
    {
      title: t('schedule.confirm.notFoundTitle'),
      message: t('schedule.confirm.notFoundDescription'),
      cta: t('schedule.confirm.selectNewAppointment'),
    },
  ],
  [
    'success',
    {
      title: t('schedule.confirm.scheduleSuccessTitle'),
      message: t('schedule.confirm.scheduleSuccessDescription'),
      cta: t('schedule.confirm.scheduleSuccessButton'),
    },
  ],
]);

export const ScheduleConfirmationModal = ({ status, modalProps, onConfirm }: ScheduleConfirmationModalProps) => {
  if (!status) return null;
  return (
    <Modal {...modalProps}>
      <Heading level="h4" className="mb-16">
        {ScheduleConfirmationModalMap.get(status)?.title}
      </Heading>
      <Heading level="h7">{ScheduleConfirmationModalMap.get(status)?.message}</Heading>
      <Button size="lg" className="mt-40" onClick={onConfirm}>
        {ScheduleConfirmationModalMap.get(status)?.cta}
      </Button>
    </Modal>
  );
};
